$(document).ready(function(){
$(".squeeze-model-btn").click(function(){
    $(".squeeze-page").show();
    $("body").addClass("squeeze-open");
})
$(".cross-svg").click(function(){
    $(".squeeze-page").hide();
     $("body").removeClass("squeeze-open");
})
 $('.sample-product-sticky-bar').appendTo('.squeeze-page-sticky');

var interval = setInterval(view, 200);
$("#judgeme_all_reviews_page").hide();
function view() {
    var select = document.querySelector("select.jdgm-sort-dropdown");
    
    if (select) {
        clearInterval(interval);
        var x = window.scrollX;
        var y = window.scrollY;
        var freezeScroll = function() {
            window.scrollTo(x, y);
        };
        window.addEventListener('scroll', freezeScroll);
        select.value = "with-pictures";
        var event = new Event('change', { bubbles: true });
        select.dispatchEvent(event);

        // Judge.me ko thoda time lagta hai DOM update karne mein
        setTimeout(function() {
            window.removeEventListener('scroll', freezeScroll);
            $("#judgeme_all_reviews_page").show();
        }, 700);
    }
}
});